import { render, staticRenderFns } from "./DatatableFiltersHandlerSidebar.vue?vue&type=template&id=0540fd0c&"
import script from "./DatatableFiltersHandlerSidebar.vue?vue&type=script&lang=js&"
export * from "./DatatableFiltersHandlerSidebar.vue?vue&type=script&lang=js&"
import style0 from "./DatatableFiltersHandlerSidebar.vue?vue&type=style&index=0&id=0540fd0c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports